import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { buildDate, version } from '../../../../environments/version';
import { DatePipe } from '@angular/common';
import packageInfo from '../../../../../package.json';

@Component({
  selector: 'pixl-about',
  imports: [
    MatDialogModule,
    MatDividerModule,
    MatButtonModule,
    DatePipe
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  private readonly dialogRef = inject(MatDialogRef<AboutComponent>);
  private readonly deps = packageInfo.dependencies as Record<string, string>;

  public readonly appVersion = version;
  public readonly appBuildDate = new Date(buildDate);
  public pixlEditorVersion: string | undefined =
    this.deps['@wdidev/pixl-editor']?.replace(/[~^]/g, '');

  public angularVersion: string | undefined =
    this.deps['@angular/core']?.replace(/[~^]/g, '');

  public onClose() {
    this.dialogRef.close();
  }
}
